import { PromotionalSku } from '../../promotional-skus/promotional-sku.class';
import { Kitchen } from '../../kitchens/kitchen.class';

export type SyncPromotionalSkuCountParams = {
	kitchen: Kitchen;
	sku: string;
	qualifyingCount: number;
};

/**
 * Additively syncs a promotional SKU count to match qualifying items — only adds missing
 * SKUs, never removes. Persisted state is authoritative on load / duplicate / import;
 * a rule recount can never destroy a serialized promo. Matches the existing add-only
 * pattern used for passthroughs / vents / insulated jackets: state wins on load, user removes
 * manually via the promotional SKUs UI.
 */
export const syncPromotionalSkuCount = (params: SyncPromotionalSkuCountParams): void => {
	const { kitchen, sku, qualifyingCount } = params;
	const { promotionalSkus } = kitchen;
	const existingCount = promotionalSkus.children.filter((s) => s.sku === sku).length;

	if (qualifyingCount > existingCount) {
		for (let i = 0; i < qualifyingCount - existingCount; i++) {
			const pSku = new PromotionalSku({ dataIn: { sku }, parent: promotionalSkus });
			promotionalSkus.children.push(pSku);
		}
	}
};
